import { render, staticRenderFns } from "./tab-item.vue?vue&type=template&id=5976a59b&scoped=true&"
import script from "./tab-item.vue?vue&type=script&lang=ts&"
export * from "./tab-item.vue?vue&type=script&lang=ts&"
import style0 from "./tab-item.vue?vue&type=style&index=0&id=5976a59b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5976a59b",
  null
  
)

export default component.exports